import { ReactComponent as ArrowBackIcon } from "../../../assets/icons/regular/arrow_back.svg";
import { BackButtonProps } from "./BackButton.interface";
import { Button } from "./BackButton.styles";

export const BackButton = ({ onClick, ...props }: BackButtonProps) => {
  return (
    <Button {...props} onClick={onClick}>
      <ArrowBackIcon />
    </Button>
  )
}
